import React, {useEffect, useState} from 'react';

import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';



const Aside2 = () => {
   const [show,setshow] = useState(true);
   const user = useSelector(state => state.root.user_login);
   const onboard_information = useSelector(state=>state.root.onboard_information);
   const onboard_education = useSelector(state=>state.root.onboard_education);
   const onboard_parish = useSelector(state=>state.root.onboard_parish);
   const onboard_perferment = useSelector(state=>state.root.onboard_perferment);
    return (
        <aside className="mdc-drawer mdc-drawer--dismissible mdc-drawer--open">
        <div className="mdc-drawer__header">
          <Link className="brand-logo" to ="/home">
            {/* <img src={require('../asset/img/logo11.png')} alt="logo"/>  */}
          </Link>
        </div>
        <div className="mdc-drawer__content">
        <div className="user-info">
        </div>
        <div className="mdc-list-group">
          <nav className="mdc-list mdc-drawer-menu">
            <div className="mdc-list-item mdc-drawer-item">
              <Link className="mdc-drawer-link" to="/onboard">
                <i className="material-icons mdc-list-item__start-detail mdc-drawer-item-icon" aria-hidden="true">person</i>
                Personal Information
              </Link>
            </div>
            {
              onboard_information != null &&  
            <div className="mdc-list-item mdc-drawer-item">
              <Link className="mdc-expansion-panel-link" to = "/onboard_priest_education" data-toggle="expansionPanel" data-target="product">
                <i className="material-icons mdc-list-item__start-detail mdc-drawer-item-icon" aria-hidden="true">book</i>
                Education
               
              </Link>
            </div>
            }
            {
              onboard_information != null &&  
            <div className="mdc-list-item mdc-drawer-item">
              <Link className="mdc-expansion-panel-link" to = "/onboard_priest_parish" data-toggle="expansionPanel" data-target="product">
                <i className="material-icons mdc-list-item__start-detail mdc-drawer-item-icon" aria-hidden="true">home</i>
                Parish
               
              </Link>
            </div>
            }
            {
              onboard_information != null &&  
            <div className="mdc-list-item mdc-drawer-item">
              <Link className="mdc-expansion-panel-link" to = "/onboard_priest_perferment" data-toggle="expansionPanel" data-target="product">
                <i className="material-icons mdc-list-item__start-detail mdc-drawer-item-icon" aria-hidden="true">person</i>
                Perferment
               
              </Link>
            </div>
            } 
          </nav>
        </div>
       
      </div>
      </aside>
        
  
    );

}

export default Aside2;